import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { categoryListApi } from "services/category";
import "./subCatManagement.scss";
import { CommonSelect, Input } from "common/InputForm";

import { ImageInput, ImagePreview } from "utils/imagePreviewURLConverter";
import useFullPageLoader from "common/UseFullPageLoader";
import { addSubCategoryApi, subCategoryMasterApi } from "services/subCategory";
import { RiArrowLeftSLine } from "react-icons/ri";
import { IoChevronBack } from "react-icons/io5";

const AddSubCat = ({
  // setAddSubCategoryModalState,
  setFetchedSubCatData,
  closeModel,
}) => {
  const [loader, onShow, onHide] = useFullPageLoader();

  // These dropdowns need every category, so they must not inherit the sub
  // category listing's page/limit from the URL - landing here from page 2 of
  // the list used to fetch page 2 of the categories into the dropdown.
  const activePage = 1;
  const limit = 1000;

  //   -------assign category data
  const [fetchedCatData, setFetchedCatData] = useState([]);
  const [seasonalFetchedCatData, setSeasonalFetchedCatData] = useState([]);
  const [subCatMaster, setSubCatMaster] = useState([]);

  const catDataFetchApiCall = async () => {
    try {
      onShow();

      const query = {
        type: "CATEGORY",
        page: activePage,
        limit: limit,
      };
      const {
        data: {
          data: { total, categories },
        },
        status,
        message,
      } = await categoryListApi(query);

      if (status === 200) {
        setFetchedCatData(categories);
      }
    } catch (error) {
      console.log("Cat Data fetch error:---> ", error);
    } finally {
      onHide();
    }
  };

  const seasonalIllnessDataFetchApiCall = async () => {
    try {
      onShow();

      const query = {
        type: "SEASONALILLNESS",
        page: activePage,
        limit: limit,
      };
      const {
        data: {
          data: { total, categories },
        },
        status,
        message,
      } = await categoryListApi(query);

      if (status === 200) {
        setSeasonalFetchedCatData(categories);
      }
    } catch (error) {
      console.log("Cat Data fetch error:---> ", error);
    } finally {
      onHide();
    }
  };

  const fetchSubCategoryMasterData = async () => {
    try {
      const query = { type: "SUBCATEGORY" };

      const {
        data: { status, code, data },
      } = await subCategoryMasterApi(query);
      if (status || code === 200) {
        setSubCatMaster(data);
      }
    } catch (error) {
      console.log("subCategoryMasterApi: error", error);
    }
  };

  useEffect(() => {
    catDataFetchApiCall();
    seasonalIllnessDataFetchApiCall();
    fetchSubCategoryMasterData();
  }, []);

  // ------------api was called in useEffect() upper in the staring of page reload-----------------

  // ----------------error state
  const [error, setError] = useState({});

  // --------Having received img link from CLOUD here it is holding it

  const [imgInputState, setImageInputState] = useState("");
  const [imgPreviewState, setImgPreviewState] = useState(null);

  const imgUploadFunction = async (e) => {
    // ---------img preview state set
    setImgPreviewState(e?.target?.files[0]);

    if (!e?.target?.files[0]?.type.includes("image/")) {
      setError((stateProp) => ({
        ...stateProp,
        imgErrorOccur: "Please Choose Image file not others",
      }));
    } else {
      try {
        const data = await imgUploadToCloudFun(e?.target?.files[0]);
        // console.log("1st data?.data[0]:-------->", data?.data[0]);
        if (data?.status === 200) {
          //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
          setImageInputState(data?.data[0]);
        }
      } catch (error) {
        console.log("error while uploading and getting data", error);
      }
    }
  };

  // -----------coupon code applicable or not state

  const [isCouponCodeApplicable, setIsCouponCodeApplicable] = useState(false);
  console.log("isCouponCodeApplicable:---->", isCouponCodeApplicable);

  const [subCatNameState, setSubCatNameState] = useState("");
  // console.log(subCatNameState);

  const [categoryState, setCategoryState] = useState("");
  // ----------will store multi selected options
  const [multiSelectOptions, setMultiSelectOptions] = useState([]);

  // -Essential
  const [typesToComponent, setTypesToComponent] = useState([]);

  const clearStateFun = () => {
    setIsCouponCodeApplicable(false);
    setSubCatNameState("");
    setCategoryState("");
    setMultiSelectOptions([]);
    setTypesToComponent([]);
    setImageInputState("");
    setImgPreviewState(null);
    setError({});
    closeModel();
  };

  const validate = () => {
    let canSubmit = true;
    let tempError = {};

    if (imgInputState === "" || imgInputState.length === 0) {
      canSubmit = false;
      tempError.cloudImgInstance = "Required Field";
    }

    if (subCatNameState === "" || subCatNameState.length === 0) {
      canSubmit = false;
      tempError.subCatNameInput = "Required Field";
    }

    if (categoryState === "" || categoryState.length === 0) {
      canSubmit = false;
      tempError.subCatStateSelect = "Required Field";
    }

    setError(tempError);
    return canSubmit;
  };

  const doSubmitFunction = async () => {
    if (validate()) {
      try {
        const data = {
          name: subCatNameState,
          image: imgInputState,
          category: categoryState,
          isCouponApplicable: isCouponCodeApplicable,
          seasonalIllness: multiSelectOptions.map((mapProp) => mapProp.value),
          collection: typesToComponent || [],
        };

        const {
          data: { code, status },
        } = await addSubCategoryApi(data);

        console.log(code, status);

        if (code === 200 || status) {
          clearStateFun();
          setFetchedSubCatData();
        }
      } catch (error) {
        console.log("Sub Cat add error:---> ", error);
      }
    }
  };

  console.log("error--->", error);

  const categoryOptions = fetchedCatData.map((item) => ({
    value: item._id,
    label: item.name,
  }));
  const selectedCategoryOption =
    categoryOptions.find((item) => item.value === categoryState) || null;

  return (
    <div className="add-cat-parent-container">
       <div className="link-header-holder">
              <p>
                <Link to={-1}>
                  <IoChevronBack />
                  Back
                </Link>
                <span>Sub Category Management</span>
                &nbsp;
                <span>/ Add Sub Category </span>
              </p>
            </div>
      <div className="sub_title has_button">
        <Link to='#'>
          <RiArrowLeftSLine onClick={() => clearStateFun()} />
        </Link>
        <h3>Add Sub Category</h3>
      </div>

      <div className="card">
        <div className="form_field_wrap">
          <div className="form_field">
            <Input
              type="text"
              label="Sub-Category Name"
              placeholder="Sub-Category Name..."
              name="subCatName"
              maxLength={50}
              value={subCatNameState}
              onChange={(e) => {
                setSubCatNameState(e.target.value);
              }}
            />

            {error.subCatNameInput && (
              <p className="errorMsg">{error.subCatNameInput}</p>
            )}
          </div>
          {/* -----category-assign */}

          {fetchedCatData.length && (
            <div className="form_field">
              <CommonSelect
                className="assign-category-search-select"
                label={"Assign Category"}
                onChange={(selectedOption) =>
                  setCategoryState(selectedOption?.value || "")
                }
                value={selectedCategoryOption}
                options={categoryOptions}
                placeholder="Search Category..."
                isSearchable={true}
              />

              {error.subCatStateSelect && (
                <p className="errorMsg">{error.subCatStateSelect}</p>
              )}
            </div>
          )}
        </div>
        <div className="form_field_wrap">
          <div className="form_field">
            {/* ---seasonal illness */}

            {seasonalFetchedCatData.length > 0 && (
              <div>
                <CommonSelect
                  value={multiSelectOptions || []}
                  label="Seasonal Illness (Optional)"
                  name="selectSeasonalIllness"
                  isMulti={true}
                  onChange={(commonSelectData) => {
                    setMultiSelectOptions(commonSelectData);
                  }}
                  // options={[
                  //   { value: "apple", label: "Apple" },
                  //   { value: "banana", label: "Banana" },
                  //   { value: "mango", label: "Mango" },
                  //   { value: "grape", label: "Grape" },
                  // ]}
                  options={seasonalFetchedCatData.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))}
                  isSearchable={true}
                />
                {/* {errors?.selectPropertyOption && (
                <p className="errorParaColor propertyListingPara">
                  {errors?.selectPropertyOption}
                </p>
              )} */}
              </div>
            )}

            {/* -----------Essentials */}

            {subCatMaster.length > 0 && (
              <div className="all-essentials">
                <SubCatTypeComponent
                  setTypesToComponent={setTypesToComponent}
                  subCatMasterData={subCatMaster}
                />
              </div>
            )}
          </div>
          <div className="form_field">
            <label className="label">Select Image (56px × 156px)</label>
            <input
              onChange={imgUploadFunction}
              type="file"
              accept="image/*"
              className="form-control input"
            />
            {error.cloudImgInstance && (
              <p className="error">{error.cloudImgInstance}</p>
            )}

            {/* ------img preview */}
            <div className="image_preview">
              <ImagePreview file={imgPreviewState} />
            </div>

            {/* -----coupon code applicable or not ?--- */}
            <div className="coupon-code-permission-container">
              <label htmlFor="Coupon-code-id">
                Coupon code Applicable{" "}
                <input
                  id="Coupon-code-id"
                  type="checkbox"
                  checked={isCouponCodeApplicable}
                  value={isCouponCodeApplicable}
                  name="Coupon-code"
                  onChange={(e) => {
                    setIsCouponCodeApplicable(!isCouponCodeApplicable);
                  }}
                />
              </label>
            </div>
          </div>
        </div>

        {/* ---------submit button */}
        <div className="submit-button-holder">
          <button type="button" className="button" onClick={doSubmitFunction}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSubCat;

const SubCatTypeComponent = ({ setTypesToComponent, subCatMasterData }) => {
  // const [data, setData] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    if (checked) {
      setTypesToComponent((prev) => [...prev, value]);
    } else {
      setTypesToComponent((prev) => prev.filter((item) => item !== value));
    }

    // sendToCatComponent(data);
  };

  return (
    <div className="select_list">
      {subCatMasterData.map((mapProp, ind) => (
        <label key={ind}>
          <input
            type="checkbox"
            name="Essentials"
            value={mapProp._id}
            onChange={handleCheckboxChange}
          />{" "}
          {mapProp?.title}
        </label>
      ))}
      {/* <label>
        <input
          type="checkbox"
          name="Essentials"
          value="Baby Essentials"
          onChange={handleCheckboxChange}
        />{" "}
        Baby Essentials
      </label>

      <label>
        <input
          type="checkbox"
          name="Essentials"
          value="Travel Essentials"
          onChange={handleCheckboxChange}
        />{" "}
        Travel Essentials
      </label>

      <label>
        <input
          type="checkbox"
          name="Essentials"
          value="Surgical Equipments"
          onChange={handleCheckboxChange}
        />{" "}
        Surgical Equipments
      </label> */}
      <br />
      {/* <button onClick={handleSubmit}>Submit</button> */}
    </div>
  );
};
